import React, { useState } from 'react';
import * as api from '../services/api.axios';
import { authService } from '../services/authService';
import { isAdminEmail } from '../utils/adminConfig';

const LoginTest = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  // Function to dynamically detect account type based on email
  const detectAccountType = (email) => {
    if (isAdminEmail(email)) return 'admin';
    if (email && (email.includes('admin') || email.includes('mgxgold') || email.includes('support') || email.includes('mgxmeta'))) {
      return 'admin';
    }
    return 'user';
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Attempting login with:', { email, password });
      
      // Dynamically detect account type
      const detectedUserType = detectAccountType(email);
      
      const response = await authService.login({ email, password, userType: detectedUserType });
      console.log('Login response:', response);
      setResult(response);
      
      // Store token in localStorage (updated to use correct property names)
      if (response.accessToken) {
        localStorage.setItem('auth_token', response.accessToken);
        console.log('Token stored in localStorage');
      }
      if (response.refreshToken) {
        localStorage.setItem('refresh_token', response.refreshToken);
        console.log('Refresh token stored in localStorage');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('mgx_user');
    localStorage.removeItem('mgx_user_type');
    setResult(null);
    console.log('Logged out and cleared localStorage');
  };

  const testAuthRequest = async () => {
    try {
      console.log('Testing authenticated request...');
      const response = await api.userApi.getUsers();
      console.log('Authenticated request response:', response);
      setResult(response);
    } catch (err) {
      console.error('Authenticated request error:', err);
      setError(err.message);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md max-w-md mx-auto mt-10">
      <h2 className="text-2xl font-bold mb-4">Login Test</h2>
      
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            required
          />
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      <div className="mt-4 space-y-2">
        <button
          onClick={handleLogout}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Logout
        </button>
        
        <button
          onClick={testAuthRequest}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          Test Auth Request
        </button>
      </div>

      {error && (
        <div className="mt-4 p-3 bg-red-50 text-red-700 rounded-md">
          <strong>Error:</strong> {error}
        </div>
      )}

      {result && (
        <div className="mt-4 p-3 bg-green-50 text-green-700 rounded-md">
          <strong>Success:</strong> Check console for details
          <pre className="mt-2 text-xs overflow-auto max-h-40">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}

      <div className="mt-4 p-3 bg-blue-50 text-blue-700 rounded-md">
        <strong>Debug Info:</strong>
        <p>Token in localStorage: {localStorage.getItem('auth_token') ? 'Yes' : 'No'}</p>
        <p>Refresh token in localStorage: {localStorage.getItem('refresh_token') ? 'Yes' : 'No'}</p>
        <p>mgx_user in localStorage: {localStorage.getItem('mgx_user') ? 'Yes' : 'No'}</p>
      </div>
    </div>
  );
};

export default LoginTest;